import { useCallback, useEffect, useRef, useState } from 'react';

const useAsyncSetState = (initialValue) => {
  const [activeItem, setActiveItem] = useState(initialValue);
  const activeItemChangeRef = useRef([]);

  useEffect(() => {
    if (activeItemChangeRef.current.length) {
      activeItemChangeRef.current.forEach((callback) => callback(activeItem));
      activeItemChangeRef.current = [];
    }
  }, [activeItem]);

  const setActiveItemId = useCallback(
    (tabId) =>
      new Promise((resolve) => {
        let isPromiseResolved = false;

        setActiveItem((prevActiveTab) => {
          if (prevActiveTab === tabId) {
            resolve(tabId);
            isPromiseResolved = true;
          }

          return tabId;
        });

        if (isPromiseResolved) return;

        activeItemChangeRef.current.push(resolve);
      }),
    []
  );

  return [activeItem, setActiveItemId];
};

export default useAsyncSetState;
